<template>
  <div class="d-flex justify-content-between">
    <b-row class="d-flex flex-nowrap row">
      <div style="margin-left: 1rem;" class="d-flex">
        <label class="mr-sm-2 d-flex align-items-center" for="inline-form-custom-select-pref"
          >Zona</label
        >

        <b-form-select @change="updateSearch()" v-model="selectedSuprazone">
          <option :value="null">Seleccione una zona</option>
          <option
            v-for="suprazone in suprazones"
            :key="suprazone.id"
            :label="suprazone.name"
            :value="suprazone.id"
          >
            {{ suprazone.name }}
          </option>
        </b-form-select>
      </div>
      <div style="margin-left: 1rem;" class="d-flex">
        <label class="mr-sm-2 d-flex align-items-center" style="align-items:center;" for="inline-form-custom-select-pref"
          >Fecha</label
        >

        <datepicker
          :value="selectedDate"
          @input="updateDate"
          style="mb-2 custom-select" 
          min="2020-1-1"
          max="2036-12-31"
          :dayStr="dayStr"
          :scrollbarProps="{isMobile: false}"
          :placeholder="placeholder"
          :firstDayOfWeek="firstDayOfWeek"
          :monthStr="monthStr"
        ></datepicker>

        <!-- <date-picker
          @input="updateSearch()"
          class="mb-2 custom-select"
          v-model="selectedDate"
          :config="dateOptions"
        ></date-picker> -->

        <!-- <b-button class="" variant="link" @click="setDateToTomorrow">
          <span>
            <i class="fa-fw fa fa-forward"></i>
            Día siguiente
          </span>
        </b-button> -->
      </div>

      <div style="margin-left: 1rem" class="d-flex">
        <label class="mr-sm-2 d-flex align-items-center" for="inline-form-custom-select-pref"
          >Grupo</label
        >

        <b-form-select @change="updateSearch()" v-model="selectedGroup">
          <option :value="0">Seleccione un grupo</option>
          <b-select-option-group label="Grupos CON gestión"></b-select-option-group>
          <option
            v-for="group in groupsListAdminManageSubset"
            :key="group.id"
            :label="group.name"
            :value="group.id"
          >
            {{ group.name }} ({{group.manage}})
          </option>
          <b-select-option-group label="Grupos sin gestión"></b-select-option-group>
          <option
            v-for="group in groupsListAdminNoManageSubset"
            :key="group.id"
            :label="group.name"
            :value="group.id"
          >
            {{ group.name }} ({{group.manage}})
          </option>
        </b-form-select>
      </div>

      <div class="align-items-baseline d-flex float-right">
        <b-button @click="resetFilters" size="sm" class="ml-2" variant="light">
          <i class="fa fa-refresh fa-fw mr-2"></i> Resetear formulario
        </b-button>
        <div v-if="trekksoftData.length === 1" class="ml-3">
          <i>Última actualización con los canales {{ trekksoftLastUpdate }}</i>
        </div>
      </div>
    </b-row>
    <b-row class="d-flex flex-nowrap row">
      <div>
        <b-dropdown
          right
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          class="float-right"
        >
          <template v-slot:button-content>
            <b-button pill variant="ligth" class="ml-3">
              <i class="fa fa-chevron-down mr-2" aria-hidden="true"></i>Emails
            </b-button>
          </template>
          <b-dropdown-item>
            <send-grid-btn />
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div>
        <b-dropdown
          right
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          class="float-right"
        >
          <template v-slot:button-content>
            <div style="width: 6vw" class="d-flex justify-content-center">
              <div v-if="showLoader">
                <custom-loader />
              </div>
              <b-button pill variant="ligth" class="ml-3" v-else>
                <i class="fa fa-chevron-down mr-2" aria-hidden="true"></i
                >Canales
              </b-button>
            </div>
          </template>
          <b-dropdown-item>
            <div @click="syncTrekk()">
              <i class="fa fa-download fa-fw mr-2"></i> Sincronizar con
              todos los canales
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>


      <b-dropdown
        dropdown
        right
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        class=""
        style=""
      >
        <template v-slot:button-content>
          <i class="fa fa-ellipsis-v"></i>
          <span class="ml-2 text-black-50">Más</span>
        </template>
        <b-dropdown-item @click="resetBusesWarning" v-b-modal="'reset_buses_modal'">
          <i class="fa fa-trash fa-fw text-danger mr-2"></i>
          <span>
            Resetear asignaciones de buses (todos)
          </span>
          <reset-buses-warning-modal />
        </b-dropdown-item>
       
        
      </b-dropdown>

    </b-row>
  </div>
</template>

<script>
/* eslint-disable */

// Import this component
//import datePicker from "vue-bootstrap-datetimepicker";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import SendGridBtn from "../Common/SendGridBtn";
import { mapGetters } from "vuex";
import { EventBus } from "../../EventBus";
import CustomLoader from "../CustomLoader/ClipLoader";
import ResetBusesWarningModal from "../Excursions/ResetBusesWarningModal";
import {Datepicker} from '@livelybone/vue-datepicker';

export default {
  name: "Filters",
  components: { 
    //datePicker, 
    SendGridBtn, 
    CustomLoader,
    ResetBusesWarningModal,
    Datepicker
  },
  data() {
    return {
      selectedDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateOptions: {
        format: "YYYY-MM-DD",
        useCurrent: false,
      },
      selectedSuprazone: null,
      selectedGroup: 0,
      showLoader: false,

      // date picker
      dayStr: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthStr: ['Enero', 'Febrero', 'Marzo', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      date: this.selectedDate,
      isM: false,
      placeholder: "Seleccionar",
      firstDayOfWeek: 1,
    };
  },
  computed: {
    ...mapGetters(["suprazones"]),
    ...mapGetters(["groups", "groupsListAdmin", "currentGroup"]),
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
    trekksoftData() {
      return this.$store.getters.trekksoftData;
    },
    path() {
      if ( this.$route.path == "/app/excursiones/excursiones") {
        return "Excursion"
      } else if ( this.$route.path.includes('pickups') ) {
        return "Pickup"
      } else if ( this.$route.path.includes('sin-parada')) {
        return "Unassigned"
      } else if ( this.$route.path.includes('orphan')) {
        return 'Orphan'
      }
    },
    trekksoftLastUpdate() {
      for (let i = 0; i < this.$store.getters.trekksoftData.length; i++) {
        const element = this.$store.getters.trekksoftData[i];
        return this.$moment(element.last_update).format("DD/MM/YYYY HH:mm");
      }
    },
    groupsListAdminManageSubset() {
      return this.groupsListAdmin.filter( (item) => item.manage )
    },
    groupsListAdminNoManageSubset() {
      return this.groupsListAdmin.filter( (item) => !item.manage )
    }
  },
  mounted() {
    // TODO: IMPORTANT!!!! this calls to updateSearch method who requests a lot of unnecessary data to backend. Move this logic to tabs¿? to request backend only information to be used on the opened view!!!!!
    const filtersLength = this.$store.getters.filtersLength;

    this.$store.dispatch("suprazones/loadSuprazones");
    this.$store.dispatch("groups/loadGroupsBySuprazone", {});

    if (filtersLength == 0) {
      this.selectedDate = this.$moment(new Date()).format("YYYY-MM-DD");
      this.selectedSuprazone = null;
      this.selectedGroup = 0;
      this.updateFilters();
    } else {
      this.selectedDate = this.$store.getters.filterDate;
      this.selectedSuprazone = this.$store.getters.filterSuprazone;
      this.selectedGroup = this.$store.getters.filterGroup;
      //this.updateSearch();
    }
  },
  methods: {
    async syncTrekk() {
      console.log('synctrek')
      this.showLoader = true;
      const date = this.$store.getters.filterDate;
      try {
        await this.$store.dispatch("trekksoft/syncTrekksoftData", date);
        const data = {
          day_init: date,
          day_end: date
        }
        console.log('sync zero tours bookings', data)
        await this.$store.dispatch("zerotours/syncZeroToursBookings", data)
      } catch (ex) {
        this.showLoader = false;
        this.error = "Failed to load data";
      } finally {
        this.showLoader = false;
        this.updateSearch();
      }
    },
    // seleccionar como fecha mañana
    setDateToTomorrow() {
      let date = new Date();
      var nextDay = new Date(date);
      nextDay.setDate(date.getDate() + 1);
      this.selectedDate = this.$moment(nextDay).format("YYYY-MM-DD");
    },
    // reiniciar filtros
    resetFilters() {
      this.selectedDate = this.$moment(new Date()).format("YYYY-MM-DD");
      this.selectedSuprazone = null;
      this.selectedGroup = 0;

      this.updateFilters();
    },
    // actualizar filtros
    updateFilters() {
      this.$store.dispatch("buses/resetBusesList");
      // 
      let filtersData = {
        suprazone: this.selectedSuprazone,
        date: this.selectedDate,
        group: this.selectedGroup,
      };
      this.$store.dispatch("filters/updateFilters", filtersData);
    },
    updateDate(val) {
      this.selectedDate = val
      this.updateSearch()
    },
    // actualizar búsqueda, llamando a las funciones para actualizar filtros y para cargar buses y reservas
    updateSearch() {
      EventBus.busesAreLoaded(false);
      EventBus.bookingsAreLoaded(false);
      this.updateFilters();
      this.loadBusesAndBookings();
    },
    // cargarmos las listas de buses y reservas si todos los filtros están seleccionados
    loadBusesAndBookings() {
      console.log("loadBusesAndBookings")
      //this.$store.commit('bookings/RESET_EXCURSION_DATA')
      //this.$store.commit('bookings/RESET_PICKUP_DATA')

      

      if (this.selectedSuprazone != null && this.selectedGroup != 0) {
        //this.$store.dispatch('layout/loadData', {reset: true}, {root: true})

        this.$store.dispatch("bookings/hasBookingsUnassigned")
        this.$store.dispatch("bookings/hasBookingsOrphanGroup")
        this.$store.dispatch("bookings/pickupzoneSummary")
        this.$store.dispatch("bookings/hasBookingsUnchecked", {})

        if ( this.activeTab == "Excursions") {
          this.$store
              .dispatch("buses/loadExcursionBuses")
              .finally(this.onBusesLoad.bind(this));
          
          this.$store.dispatch("buses/busesPath")

          if ( this.activeOption == "Activity" ) {
            this.$store
              .dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'})
              .finally(
                this.onBookingsLoad.bind(this)
              );
          } else if ( this.activeOption == 'NoService' ) {
            console.log('load false')
            this.$store
              .dispatch(
                  "bookings/loadBookingsByActivityOrdered", 
                  {order_by: 'booking__order_1,customer_language', exclude_no_bus_excursion_service: 'False'}
              )
              .finally(
                this.onBookingsLoad.bind(this)
              );
          } else if ( this.activeOption == 'Excursion') {
            
          } else if  ( this.activeOption == 'Path') {
            this.$store.dispatch("buses/busesPath")
          }
          
        } else if (this.activeTab == "Pickups") {
          this.$store
            .dispatch("buses/loadPickupBuses")
            .finally(this.onBusesLoad.bind(this));
          

          if ( this.activeOption == 'Stop') {
            this.$store
              .dispatch("bookings/loadBookingsByStop")
              .finally(this.onBookingsLoad.bind(this));
          } else if ( this.active == 'Pickup') {

          } else if ( this.activeOption == 'Excursion') {
            
          } else if ( this.activeOption == 'Path') {
            this.$store.dispatch("buses/busesPath")
          }
        } else if ( this.activeTab == 'Unassigned') {
          this.$store.dispatch("bookings/loadBookingsUnassigned")
        } else if ( this.activeTab == 'Orphan') {
          this.$store.dispatch("bookings/loadOrphanBookings")
        } else if ( this.activeTab == 'Send' ) {
          this.$store
            .dispatch("buses/sentPlanningData") 
        } else if ( this.activeTab == 'Check' ) {
          this.$store.dispatch("bookings/loadBookingsByActivityForCheckingOrdered", 
            {order_by: 'id,customer_language'})
        }
        
      }
    },
    onBusesLoad() {
      setTimeout(() => {
        console.log("onBusesLoad true")
        EventBus.busesAreLoaded(true);
      }, 1500);
    },
    onBookingsLoad() {
      //setTimeout(() => {
        console.log("onBookingsLoad true")
        EventBus.bookingsAreLoaded(true);
      //}, 4000);
    },
    resetBusesWarning() {
    }
  },
  watch: {
    selectedSuprazone: async function(newSelectedSuprazone, oldSuprazone) {
      const data = {
        suprazone_id: newSelectedSuprazone,
      }
      await this.$store.dispatch("groups/loadGroupsBySuprazone", data);
      if ( newSelectedSuprazone !== oldSuprazone && oldSuprazone !== null) {
        console.log(newSelectedSuprazone, oldSuprazone)
        this.$store.commit('bookings/RESET_EXCURSION_DATA')
        this.$store.commit('bookings/RESET_PICKUP_DATA')
        this.selectedGroup = 0
      }
      
      

      this.updateFilters()
    }
  }
};
</script>


<style lang="css" src="@livelybone/vue-datepicker/lib/css/index.css"></style>

<style > 
.datepicker {
    background: white;
}
.datepicker, .datepicker, .timepicker, .datetime-picker {
    height: 30px !important;
}
.datepicker .input-wrapper, .datepicker .input-wrapper, .timepicker .input-wrapper, .datetime-picker .input-wrapper {
    border: 1px solid #999 !important;
    border-radius: 0px !important;
}
.datepicker .vue-input {
    font-size: 12px !important;
}
.datepicker .picker .picker-items .row-item .item.selected::before {
    background: #e7ce28;
    border-radius: 3px;
    border: 1px solid #e7ce28;
} 
.datepicker .picker .picker-items .row-item .item.is-now::before {
    border: 1px solid #e7ce28;
}
.datepicker .picker .picker-items .row-item .item.is-now {
  color: black;
  font-weight: bold;
}
.datepicker .picker .picker-items .row-item .item.selected {
  color: black;
}
</style>